import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Button,
    CardActions,
    CardContent,
    TextField,
    CardHeader,
    Grid, FormControlLabel, Switch,
} from "@mui/material";
import {setModal} from "../../../../../Common/App";
import {DialogCard, Loader} from "../../../../../../Components";
import {addStatusType, updateStatusType} from "../../../Redux/Action";

const INITIAL_DATA = {
    id: null,
    name: '',
    description: '',
    is_template: 0,
};

export const StatusTypeModal = ({item, setItems}) => {

    const dispatch = useDispatch();
    const [disabled, setDisabled] = useState(false);
    const [errors, setErrors] = useState({});
    const [, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(INITIAL_DATA);

    useEffect(() => {
        if (item) {
            setData({
                id: item.id,
                name: item.name,
                description: item.description,
                is_template: item.is_template || 0,
            });
        }
    }, [item]);

    const handleSaveOrUpdate = async () => {
        setIsLoading(true);
        if (data.id) {
            await updateStatusType({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setData(INITIAL_DATA);
                    setItems((prev) => prev.map((item) => (item.id === res.data?.id ? res.data : item)));
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        } else {
            await addStatusType({ dispatch, data }).then((res) => {
                setIsLoading(false);
                if (res.success) {
                    setData(INITIAL_DATA);
                    setItems((prev) => [...prev, res.data]);
                    dispatch(setModal({component:null, open:false}));
                }
                setErrors(res.errors);
                setMessage(res.message);
            });
        }
    };

    const handleChange = (e) => {
        setErrors({});
        setDisabled(false);
        const {name, value} = e.target;
        setData({...data, [name]: value});
    }

    const handleSwitchChange = (name, value) => {
        setData((prev) => ({
            ...prev,
            [name]: prev[name] === value ? 0 : value,
        }));
    };

    return (
        <DialogCard>
            <CardHeader 
                title="Status Type"
                avatar={<Loader isLoading={isLoading} type={"linear"} />}
            />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label="Name"
                            placeholder={"TASK, PAYROLL, LEAVE"}
                            value={data?.name || ''}
                            name="name"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.name}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            multiline
                            rows={2}
                            label="Description"
                            value={data?.description || ''}
                            name="description"
                            onChange={(e) => handleChange(e)}
                            variant="outlined"
                            helperText={errors?.description}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel
                            label={"Is Template"}
                            labelPlacement="start"
                            control={
                                <Switch
                                    color="primary"
                                    size="small"
                                    checked={!!data?.is_template}
                                    onChange={() => handleSwitchChange('is_template', 1)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            }
                        />
                    </Grid>
                </Grid>
            </CardContent>
            <CardActions>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button disabled={disabled} variant="contained" color={'primary'} onClick={ handleSaveOrUpdate }>{ data['id'] ? 'Update' : 'Add'}</Button>
            </CardActions>
        </DialogCard>
    )
}